<template lang="pug">
  .dashboard-members
    v-card(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true" :class="$vuetify.breakpoint.smAndDown ? '' : 'mx-2 pt-2'")
      .main-container
        v-tabs(v-model="selectedType" color="textColorAccent" :height="40" grow)
          v-tab.button-AA-medium {{ $t('by_sales_amount') }}
          v-tab.button-AA-medium {{ $t('by_conversion_rate') }}
        div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
      //- div.pa-4.my-2
      //-   v-text-field(v-model="searchText" hide-details dense solo flat background-color="basic200" :style="{'border-color': $vuetify.theme.themes[$theme].basic400}" style="border-color: basic400; border-style: solid; border-width: 1px;"  height="50")
      //-     template(v-slot:label)
      //-       .p1.basic600--text Search member
      //-     template(v-slot:append)
      //-       eva-icon(name="search" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic600")
      v-layout.mx-4.mb-3.mt-4
        .s2.primary400--text {{ $t('rank') }}
        .s2.primary400--text.ml-4 {{ $t('member_name') }}
        v-spacer
        .s2.primary400--text(v-if="rankingType == 'sales'") {{ $t('sales') }} ({{ $currency.symbol }})
        .s2.primary400--text(v-else) {{ $t('conversion_rate') }}
      v-divider.basic300
      div(v-if="members.length == 0")
        .s2.ma-4.text-center {{ $t('no_matching_records') }}
      div(v-else v-for="(member, index) in  members" :key="member.id")
        v-layout.px-4(style="height:48px" :class="index % 2 === 0? 'basic200' : ''")
          div.text-center.my-auto(style="min-width:30px") 
            .p2.textColor--text {{ member.rank}}
          .s2.textColor--text.ml-4.my-auto(style="max-height:26px; overflow: hidden;") {{ member.first_name }} {{ member.last_name }} ({{ member.role }})
          v-spacer
          div.text-right.my-auto(v-if="rankingType == 'sales'" style="min-width:90px") 
            .p2.textColor--text {{ member.sales_amount | displayPriceRaw }}
          div.text-right.my-auto(v-else style="min-width:70px") 
            .p2.textColor--text {{ member.conversion_rate | percentage }}
        v-divider.basic300

</template>

<script>
export default {
  props: ['company', 'span', 'dateRange'],
  data () {
    return {
      selectedType: 0,
      rankingType: 'sales',
      totalMembers: 0,
      responseMembers: [],
      members: [],
      searchText: '',
      loading: true
    }
  },
  watch: {
    selectedType (val) {
      if (val == 0) {
        this.rankingType = 'sales'
      } else {
        this.rankingType = 'conversion'
      }
    },
    rankingType () {
      this.fetchMembers()
    },
    searchText (val) {
      this.members = this.responseMembers
      if (val) {
        this.members = this.members.filter((member) => member.first_name.toLowerCase().includes(val.toLowerCase()) ||  member.last_name.toLowerCase().includes(val.toLowerCase()) || (member.first_name + ' ' + member.last_name).toLowerCase().includes(val.toLowerCase()) )
      }
    },
    span: {
      handler (val) {
        if (val !== 'custom') {
          this.fetchMembers()
        }
      },
      deep: true
    },
    dateRange (val) {
      if (val.length === 2) {
        this.fetchMembers()
      }
    }
  },
  mounted () {
    this.fetchMembers()
  },
  methods: {
    fetchMembers() {
      this.loading = true
      let url = `/members/${this.rankingType}_ranking/?page=1&page_size=20&company=${this.company.id}&ordering=-id&span=${this.span}`
      if (this.span === 'custom') {
        url = `/members/${this.rankingType}_ranking/?page=1&page_size=20&company=${this.company.id}&ordering=-id&from=${this.dateRange[0]}&until=${this.dateRange[1]}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.members = response.data.results.map((p, index) => { return { ...p, rank: index + 1 } })
        this.responseMembers = this.members
        this.totalMembers = response.data.count
        this.loading = false
        if (this.searchText) {
          this.members = this.members.filter((member) => member.first_name.toLowerCase().includes(this.searchText.toLowerCase()) ||  member.last_name.toLowerCase().includes(this.searchText.toLowerCase()) || (member.first_name + ' ' + member.last_name).toLowerCase().includes(this.searchText.toLowerCase()) )
        }
      }).catch(() => {})
    },
    roleColor (role) {
      if (role == 'Admin') {
        return '#D6AF36'
      }
      else if (role == 'Salesperson') {
        return 'blue'
      }
      else if (role == 'Agent') {
        return 'green'
      }
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "by_sales_amount": "by sales amount",
    "by_conversion_rate": "by conversion rate",
    "member_name": "Member name",
    "conversion_rate": "Conversion rate",
    "no_matching_records": "No matching records found"
  },
  "id": {
    "by_sales_amount": "berdasarkan jumlah penjualan",
    "by_conversion_rate": "berdasarkan tingkat konversi",
    "member_name": "Nama Anggota",
    "conversion_rate": "Tingkat konversi",
    "no_matching_records": "Tidak ada catatan ditemukan"
  }
}
</i18n>